<div class="wizard-topbar">
  <div class="topbar-start">
    <app-logo></app-logo>
  </div>

  <div class="topbar-end">
    <button
      pButton
      type="button"
      icon="pi pi-times"
      class="close-button p-button-text p-button-rounded"
      (click)="onCloseClick()"
      pTooltip="Κλείσιμο"
      tooltipPosition="bottom"
    ></button>
  </div>
</div>

